import { Box, IconButton, Stack, Typography } from 'src/components/mui';
import { useMenuContext } from '../context';
import { EMenuOpenType } from '../types';

type Props = {
  onClose?: () => void;
  toggleSearchBar?: () => void;
};

export const Header = ({ onClose, toggleSearchBar }: Props) => {
  const { colors, openType, translation } = useMenuContext();
  const defaultTitle = openType === EMenuOpenType.BM ? 'Menu' : 'IoT Menu';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 0.5,
        width: '100%',
      }}
    >
      <Typography
        variant="h6"
        color={colors.text}
        sx={{
          textWrap: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {translation?.menu || defaultTitle}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={1} sx={{ color: colors.text }}>
        {!!toggleSearchBar && (
          <IconButton
            sx={{
              color: colors.search,
            }}
            onClick={toggleSearchBar}
          >
            <i
              className="fas fa-search fa-fw"
              style={{
                fontSize: '16px',
              }}
            />
          </IconButton>
        )}
        {!!onClose && (
          <IconButton color="inherit" onClick={onClose}>
            <i className="fas fa-times fa-fw" />
          </IconButton>
        )}
      </Stack>
    </Box>
  );
};
